import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        'secondary-sm':
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 text-[10px] px-1.5 py-0',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        'destructive-outline':
          'border-destructive/30 text-destructive bg-destructive/5 hover:bg-destructive/80 hover:text-white transition-colors transition-opacity duration-150',
        'primary-dark':
          'border-destructive/20 text-white/80 bg-destructive/20 hover:bg-secondary/50 hover:text-white transition-colors transition-opacity duration-150',
        outline: 'text-foreground',
        'outline-sm': 'text-foreground text-[10px]',
        black: 'text-white bg-black border-transparent shadow hover:bg-black/80 px-1.5',
        'black-sm':
          'text-[10px] text-white bg-black border-transparent shadow hover:bg-black/80 px-1.5',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
